import { RRule } from 'rrule';
import { invert } from 'lodash';

const membershipBillingFrequency = {
  daily: (new RRule({ freq: RRule.DAILY })).toString(),
  monthly: (new RRule({ freq: RRule.MONTHLY })).toString(),
  quarterly: (new RRule({ freq: RRule.MONTHLY, interval: 3 })).toString(),
  semiannually: (new RRule({ freq: RRule.MONTHLY, interval: 6 })).toString(),
  annually: (new RRule({ freq: RRule.YEARLY })).toString(),
};

export const humanizeMembershipBillingFreq = (rruleBillingCycle) => {
  return invert(membershipBillingFrequency)[rruleBillingCycle];
};

export default membershipBillingFrequency;
